import { Box, Button, Stack, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Overview } from "@repo/ui";
import bulletPointImg from "@repo/ui/assets/images/bulletXS.png";

export const StyledOverview = styled((props) => (
    <Overview
        {...props}
        sx={{
            overflow: { md: "visible", xs: "hidden" },
            p: { md: 0, xs: 1 },
            pt: { md: 1 },
            borderRadius: 1,
            ".MuiCardContent-root": {
                boxShadow: (theme) => theme.customShadows.close,
                borderRadius: 1,
                backgroundColor: "white.main",
            },
            ".MuiCardMedia-root": {
                display: { md: "none" },
                backgroundPositionY: "2px",
            },
            ...props.sx,
        }}
    />
))({});

export const ContentBox = styled(Box)(({ theme }) =>
    theme.unstable_sx({
        ml: { md: 3, xs: 2 },
        mr: { md: 3, xs: 2 },
    }),
);

export const DividerText = styled(Typography)(({ theme }) =>
    theme.unstable_sx({
        color: "grey.dark",
        px: 3,
    }),
);

export const ActionStack = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        mt: 5,
    }),
);

export const ActionButton = styled(Button)(({ theme }) =>
    theme.unstable_sx({
        width: "50%",
        py: "11px",
    }),
);

export const ProductStack = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        marginTop: "12px",
        p: 5,
        boxShadow: theme.customShadows.close,
        borderRadius: 1,
        backgroundColor: "white.main",
    }),
);

export const ProductTextStack = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        marginBottom: "12px",
    }),
);

export const BulletListContainer = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        marginLeft: -4,
        fontSize: { xs: 14, md: 16 },
        flexWrap: "wrap",
    }),
);

export const BulletListWrapper = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        flexDirection: "row",
        flexWrap: "wrap",
        justifyContent: "space-between",
    }),
);

export const BulletListColumn = styled(Stack)<{ width?: { xs: string; md: string } }>(({ theme, width }) =>
    theme.unstable_sx({
        width: width ?? { xs: "100%", md: "53%" },
    }),
);

export const BulletListPrimaryColumn = styled(BulletListColumn)(({ theme }) =>
    theme.unstable_sx({
        width: { xs: "100%", md: "53%" },
    }),
);

export const BulletListSecondaryColumn = styled(BulletListColumn)(({ theme }) =>
    theme.unstable_sx({
        width: { xs: "100%", md: "47%" },
    }),
);

export const BulletList = styled("ul")({
    marginTop: 0,
    listStyleImage: `url(${bulletPointImg})`,
    textWrap: "nowrap",
});

export const BulletListFull = styled("ul")({
    marginTop: 0,
    listStyleImage: `url(${bulletPointImg})`,
});

export const BulletItem = styled("li")({
    marginBottom: 4,
});

export const ProductButtonWrapper = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        width: "100%",
        textAlign: "center",
        px: { xs: 5 },
    }),
);
